// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import setReorderPadFilterQuery from "@adl/App/Handlers/ReorderPad/SetReorderPadFilterQuery";
import { CustomAppState, ReorderPadProductFilters } from "@adl/App/Store/Reducers";
import { createHandlerChainRunner, HandlerWithResult } from "@insite/client-framework/HandlerCreator";
import cloneDeep from "lodash/cloneDeep";
import merge from "lodash/merge";

type HandlerType = HandlerWithResult<ReorderPadProductFilters, ReorderPadProductFilters>;

export const MergeParameter: HandlerType = props => {
    const currentFilters = cloneDeep((props.getState() as CustomAppState).xReorderPad.productFilters);
    props.result = merge(currentFilters, props.parameter);
};

export const AbortOnDuplicateFilter: HandlerType = props => {
    const currentFilters = (props.getState() as CustomAppState).xReorderPad.productFilters;
    if (props.parameter.searchWithin?.filter(x => currentFilters.searchWithin?.includes(x)).length) {
        return false;
    }
};

export const ResetPage: HandlerType = props => {
    if (props.parameter.pageSize || props.parameter.sort || props.parameter.searchWithin?.length) {
        props.result.page = undefined;
    }
};

export const AddSearchWithin: HandlerType = props => {
    const currentFilters = (props.getState() as CustomAppState).xReorderPad.productFilters;
    props.result.searchWithin = currentFilters.searchWithin;

    if (props.parameter.searchWithin) {
        // must copy array or props don't update
        props.result.searchWithin = props.result.searchWithin
            ? props.result.searchWithin.concat(props.parameter.searchWithin)
            : props.parameter.searchWithin;
    }
};

export const AddFromDateFilter: HandlerType = props => {
    if (props.parameter.fromDate !== undefined) {
        props.result.fromDate = props.parameter.fromDate;
    }
};

export const AddToDateFilter: HandlerType = props => {
    if (props.parameter.toDate !== undefined) {
        props.result.toDate = props.parameter.toDate;
    }
};

export const DispatchSetProductFilters: HandlerType = props => {
    props.dispatch({
        type: "xReorderPad/SetProductFilters" as any,
        result: props.result,
    });
};

export const DispatchSetFilterQuery: HandlerType = props => {
    props.dispatch(setReorderPadFilterQuery());
};

export const chain = [
    MergeParameter,
    AbortOnDuplicateFilter,
    ResetPage,
    AddSearchWithin,
    AddFromDateFilter,
    AddToDateFilter,
    DispatchSetProductFilters,
    DispatchSetFilterQuery,
];

const addReorderPadFilters = createHandlerChainRunner(chain, "AddReorderPadFilters");
export default addReorderPadFilters;
